import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import { Exam } from '../../../lib/types';

export interface ExamStateModel {
  item: EntityData<Exam>;
}

export const examStateDefaults: ExamStateModel = {
  item: initialEntityData()
};
